// extracted by mini-css-extract-plugin
var _1 = "uR8MR";
export { _1 as "borderWarningDark" }
